/**
 * DE: Kennungen der drei Reiter.
 * EN: Ids of the three tabs.
 */
export type TabId = 'today' | 'plan' | 'shopping';

/**
 * DE: Wechselt den Reiter; ohne Router geht das nur über das Ionic-Element.
 * EN: Switches the tab; without a router this only works through the Ionic element.
 */
export function selectTab(tab: TabId): void {
  void document.querySelector('ion-tabs')?.select(tab);
}
